/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { INTUO_URL, INTUO_CATALOG_URL, DOCEBO_URL } from '../../../app.constants';
import { setTitleComponent } from 'src/app/utils/titles.util';
import { Title } from '@angular/platform-browser';
import { AppState } from 'src/app/store/state/app.state';

@Component({
    selector: 'u4-cpp-intuo',
    templateUrl: './intuo.component.html',
    styleUrls: ['./intuo.component.scss'],
})
export class IntuoComponent implements OnDestroy, OnInit {

    public labels: {[key: string]: string};
    public redirectUrl = INTUO_URL;
    public redirectCatalogUrl =  INTUO_CATALOG_URL;
    public redirectUrlPartner: string;
    public email: string;
    public firstDescriptionOne: string;
    public firstDescriptionTwo: string;
    public firstDescriptionThree: string;
    public secondDescriptionOne: string;
    public secondDescriptionTwo: string;
    public secondDescriptionThree: string;
    public norske: string;
    public svensk: string;
    public title$ = new Observable<any>();
    public hasDoceboPermission = false;
    public hasDoceboPartnerPermission = false;
    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private store: Store<AppState>,
        private titleService: Title
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => { 
            this.labels = labels;
            this.email = this.labels['intuo.description.part.one.email'];
            this.norske = this.labels['intuo.description.part.two.norske'];
            this.svensk = this.labels['intuo.description.part.two.svensk'];
            this.firstDescriptionOne = this.labels['intuo.description.part.one.line.one'];
            this.firstDescriptionTwo = this.labels['intuo.description.part.one.line.two'];      
            this.firstDescriptionThree = this.labels['intuo.description.part.one.line.three'];
      
            this.secondDescriptionOne = this.labels['intuo.description.part.two.line.one'];
            this.secondDescriptionTwo = this.labels['intuo.description.part.two.line.two'];
            this.secondDescriptionThree = this.labels['intuo.description.part.two.line.three'];
            this.titleService.setTitle(setTitleComponent(this.labels['intuo.title']));
        });
        this.store.select(state => state.profile).pipe(
            takeUntil(this.destroy$)
        ).subscribe(profile => { 
            if ( profile.permissions.some((item) => item === 'DOCEBO_PARTNER')) {
                this.hasDoceboPartnerPermission = true;
                this.redirectUrlPartner = DOCEBO_URL;
            }
            else if (profile.permissions.some((item) => item === 'DOCEBO')) {
                this.hasDoceboPermission = true;
                this.redirectUrl = DOCEBO_URL;
            }
        });
    }

    ngOnInit(){
    // this.store.select(state => state.labels).pipe(
    //   takeUntil(this.destroy$)
    // ).subscribe(labels =>{ 
    //   this.labels = labels;
    //   this.email = this.labels["intuo.description.part.one.email"];
    //   this.norske = this.labels["intuo.description.part.two.norske"];
    //   this.svensk = this.labels["intuo.description.part.two.svensk"];
    //   this.firstDescriptionOne = this.labels["intuo.description.part.one.line.one"];
    //   this.firstDescriptionTwo = this.labels["intuo.description.part.one.line.two"];      
    //   this.firstDescriptionThree = this.labels["intuo.description.part.one.line.three"];
      
    //   this.secondDescriptionOne = this.labels["intuo.description.part.two.line.one"];
    //   this.secondDescriptionTwo = this.labels["intuo.description.part.two.line.two"];
    //   this.secondDescriptionThree = this.labels["intuo.description.part.two.line.three"];
    //   this.titleService.setTitle(setTitleComponent(this.labels['intuo.title']));
    // });
    }
  
    getBeginningOfSentence(sentence: string): string {
        return sentence.slice(0, sentence.indexOf('{'));
    }
  
    getMiddleOfSentence(sentence: string): string {
        return sentence.slice((sentence.lastIndexOf('{') + 1), sentence.indexOf('}'));
    }

    getEndOfSentence(sentence: string): string {
        return sentence.slice(sentence.lastIndexOf('}') + 1);
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
